import { Component } from '@angular/core';
import { TranslateDirective, TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';
import { ModalNotificationImageDirective } from '../../image/modal-notification-image.directive';

@Component({
  imports: [
    TranslateDirective,
    NgxTranslatePipe,
    ModalNotificationImageDirective
  ],
  selector: 'td-wb-modal-notification-fully-paid-lending',
  templateUrl: 'modal-notification-fully-paid-lending.component.html',
  styleUrls: [
    '../modal-notification-common.component.scss',
    'modal-notification-fully-paid-lending.component.scss'
  ]
})
export class ModalNotificationFullyPaidLendingComponent {
}
